import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import PageRenderer from "./pages/PageRenderer";
import Home from "./pages/Home";
import Holdstart from "./pages/Holdstart";
import Kontakt from "./pages/Kontakt";

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-white text-slate-800 antialiased">
        {/* Header Navigation */}
        <Navbar />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/priser" element={<PageRenderer customSlug="priser" />} />
            <Route path="/holdstart" element={<Holdstart />} />
            <Route path="/materialer" element={<PageRenderer customSlug="materialer" />} />
            <Route path="/nyheder" element={<PageRenderer customSlug="nyheder" />} />
            <Route path="/vores-ydelser" element={<PageRenderer customSlug="vores-ydelser" />} />
            <Route path="/foerstehjaelp" element={<PageRenderer customSlug="foerstehjaelp" />} />
            <Route path="/om-os" element={<PageRenderer customSlug="om-os" />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="*" element={<PageRenderer />} />
          </Routes>
        </main>

        {/* Footer Area */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
